import { render, staticRenderFns } from "./analogsRender.vue?vue&type=template&id=59f27af4&scoped=true"
import script from "./analogsRender.vue?vue&type=script&lang=js"
export * from "./analogsRender.vue?vue&type=script&lang=js"
import style0 from "./analogsRender.vue?vue&type=style&index=0&id=59f27af4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f27af4",
  null
  
)

export default component.exports